import { useQuery } from "@tanstack/react-query";
import { apiGet } from "./client";

// Cohorts come from the data (each endpoint returns the funded years it actually has), not a
// fixed list of years -- same idea as the Expected Loss chart's rolling window.
export type CohortYear = string;

// One colour per line, by position in the list of lines (cohorts, vintages, ranges, variables) -- the set of
// years changes with the data, so this can't be a fixed per-year map. Every entry is its own hue, so no two lines
// on a chart share a colour (the earlier palette repeated amber, red and green through its theme tokens), and the
// list is long enough for the most lines any chart draws (20). Every multi-line chart in Portfolio Performance
// takes its colours from here.
export const SERIES_PALETTE = [
  "#f59e0b", "#14b8a6", "#a855f7", "#ef4444", "#3b82f6",
  "#22c55e", "#ec4899", "#eab308", "#06b6d4", "#f97316",
  "#8b5cf6", "#84cc16", "#f43f5e", "#0ea5e9", "#d946ef",
  "#10b981", "#fb7185", "#6366f1", "#a3e635", "#94a3b8",
];
const COHORT_PALETTE = SERIES_PALETTE;

export function cohortColor(index: number): string {
  return COHORT_PALETTE[index % COHORT_PALETTE.length]!;
}

export interface MonthRow {
  month: string;
  [cohort: string]: string | number;
}

export interface LifetimeLossProjectionsSummary {
  forecast: MonthRow[]; // actual
  projection: MonthRow[]; // dotted
}

export function useLifetimeLossProjections(industry: string) {
  return useQuery({
    queryKey: ["lifetime-loss-projections", industry],
    queryFn: () =>
      apiGet<LifetimeLossProjectionsSummary>("/lifetime-loss-projections", { industry }),
  });
}
